import * as React from 'react';

const YahooIcon$2 = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#5F01D2",
        fillRule: "evenodd",
        d: "M1 5.74 4.92 15l-1.4 3.33h3.44l5.23-12.6H8.76l-2.13 5.4-2.1-5.4zm9.47 7.24c0 1.16.9 2.1 2.1 2.1 1.25 0 2.19-.98 2.19-2.17 0-1.18-.9-2.11-2.11-2.11-1.25 0-2.18 1-2.18 2.18m4.68-11.31L11.7 9.99h3.85L19 1.67z",
        clipRule: "evenodd"
    }));

export { YahooIcon$2 as YahooIcon };
//# sourceMappingURL=Yahoo.mjs.map
